import { render, staticRenderFns } from "./GradeStatusChange.vue?vue&type=template&id=4fce4488&scoped=true"
import script from "./GradeStatusChange.vue?vue&type=script&lang=js"
export * from "./GradeStatusChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce4488",
  null
  
)

export default component.exports